import apiClient from '../client';
import { checkoutHeaders } from './paymentApi';

/**
 * POST /checkout/initiate
 * Sends an OTP email to the given address.
 * Returns { message: "OTP sent to <email>" }
 */
export const sendCheckoutOtp = async (email) => {
  const { data } = await apiClient.post('/checkout/initiate', { email });
  return data;
};

/**
 * POST /checkout/verify-otp
 * Verifies the OTP entered by the user.
 * Returns { checkoutToken } on success; throws on invalid/expired OTP.
 */
export const verifyCheckoutOtp = async (email, otp) => {
  const { data } = await apiClient.post('/checkout/verify-otp', { email, otp });
  return data; // { checkoutToken }
};

/**
 * GET /checkout/addresses
 * Addresses the shopper delivered to before (and, when signed in, their address book) — newest first, at most 5.
 * Needs proof of the e-mail: the login JWT (sent by apiClient) or the guest checkout token. Returns [] on any failure,
 * so checkout simply falls back to an empty form.
 */
export const getSavedAddresses = async () => {
  try {
    const { data } = await apiClient.get('/checkout/addresses', { headers: checkoutHeaders() });
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};
